export default __webpack_public_path__ + "static/media/icon-arrow-left.e9bb7637.svg";